import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import error from "./modules/error";
import sync from "./modules/sync";
import settings from "./modules/settings";
import runningLog from "./modules/runningLog";

Vue.use(Vuex);
const debug = process.env.VUE_APP_ENV !== "production";

import VuexPersistence from "vuex-persist";
import Cookies from "js-cookie";
const vuexCookie = new VuexPersistence({
  key: "cookieStore",
  restoreState: (key) => Cookies.get(key),
  saveState: (key, state) =>
    Cookies.set(key, state, {
      expires: 30, // expire in 30 days
    }),
  modules: [
    //
  ],
});
const vuexLocal = new VuexPersistence({
  key: "localStore",
  storage: window.localStorage,
  modules: ["auth", "error", "settings", "sync", "runningLog"],
});

export default new Vuex.Store({
  modules: {
    auth: auth,
    error: error,
    settings: settings,
    sync: sync,
    runningLog: runningLog,
  },
  strict: debug,
  plugins: [vuexCookie.plugin, vuexLocal.plugin],
});
